import axios from "axios";

export const login = async (username, password, rememberMe, config={}) => {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);
    formData.append("remember_me", rememberMe ? "true" : "false");
    const url = `/api/v1/login/access-token`;

    const res = await axios.post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        ...config,
    });

    return res.data;
};


export const logout = async (config={}) => {
    const url = `/api/v1/logout`;
    const res = await axios.post(url, {}, config);
    return res.data;
}

export const refresh = async (config={}) => {
    const url = `/api/v1/login/refresh-token`;
    const res = await axios.post(url, {}, {withCredentials: true, ...config});
    return res.data;
}

export const passwordRecovery = async (email, config={}) => {
    const url = `/api/v1/password-recovery/${email}`;
    const res = await axios.post(url, {}, config);
    return res.data;
}

export const passwordReset = async (data, config={}) => {
    const url = `/api/v1/password-reset`;
    const res = await axios.post(url, data, config);
    return res.data;
}

export const getAuthorizations = async () => {
    const url = `/api/v1/authorizations`;
    const res = await axios.get(url);
    return res.data;

}

export const sendEmailConfirmation = async (data, config={}) => {
    const url = `/api/v1/send-email-confirmation`;
    const res = await axios.post(url, data, config);
    return res.data;
}

export const confirmEmail = async (data, config={}) => {
    const url = `/api/v1/confirm-email`;
    const res = await axios.post(url, data, config);
    return res.data;
}